import React from 'react'
import PropTypes from 'prop-types'

import { Typography } from '@material-ui/core'

import Image from 'artkive/components/Image'
import ProductDescriptionItem from 'artkive/components/PageSections/ProductDescriptionItem'

import { ImageWrapButton, LearnMoreButtonLink, TextWrap } from './ProductItem.style'

const ProductItem = ({ title, descriptionItems, image, url, trackerEvent, trackerOptions }) => {
  return (
    <>
      <ImageWrapButton
        aria-label={`Learn more about ${title}`}
        href={url}
        trackerEvent={trackerEvent}
        trackerOptions={trackerOptions}
      >
        <Image alt={title} src={image} loading='eager' />
      </ImageWrapButton>
      <TextWrap>
        <Typography variant='h3'>{title}</Typography>
        {descriptionItems.map((descriptionItem, index) => (
          <ProductDescriptionItem key={index}>{descriptionItem}</ProductDescriptionItem>
        ))}
      </TextWrap>
      <LearnMoreButtonLink
        color='primary'
        href={url}
        variant='outlined'
        trackerEvent={trackerEvent}
        trackerOptions={trackerOptions}
      >
        Learn More
      </LearnMoreButtonLink>
    </>
  )
}

ProductItem.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  trackerEvent: PropTypes.string.isRequired,
  trackerOptions: PropTypes.shape({
    section: PropTypes.string,
  }).isRequired,
}

export default ProductItem
